import axios from "axios";
import {store} from '@/store';

const ApiService = {
    _requestInterceptor: 0,
    _401interceptor: 0,

    setHeader() {
        // axios.defaults.headers.common[
        //     "Authorization"
        //     ] = `Bearer ${TokenService.getToken()}`;
    },

    removeHeader() {
        axios.defaults.headers.common = {};
    },

    get(url) {
        return axios.get(url);
    },

    post(url, data) {
        return axios.post(url, data);
    },

    patch(url, data) {
        return axios.patch(url, data);
    },

    put(url, data) {
        return axios.put(url, data);
    },

    delete(url, data) {
        if (data) {
            return axios.delete(url, { data: data});
        } else {
            return axios.delete(url);
        }
    },

    customRequest(request) {
        return axios(request);
    },

    mountRequestInterceptor() {
        this._requestInterceptor = axios.interceptors.request.use(async config => {
            console.log("show loading bar");
            return config;
        });
    },

    catchError(error) {
        console.log("api error", error.message)

        let status;
        let description;
        let errorNumber;
        let errorMessage;
        let errorFields;
        let errorType;

        if (error.response === undefined) {
            status = error.message;
            description = error.message;
        } else {
            status = error.response.status;
            description = error.response.data.error_description;
            errorNumber = error.response.data.errorNumber;
            errorMessage = error.response.data.errorMessage;
            errorFields = error.response.data.errorFields;
            errorType = error.response.data.errorType;
        }

        throw {status, description, errorNumber, errorMessage, errorFields, errorType};
    }
}

export default ApiService;
